<script lang="ts">
	import { getBlogArticleSubHeading } from '../blogHelpers';
	import type { SbBlogArticleStory } from '../types';
	import DesktopPageGrid from './desktopPageGrid.svelte';
	import Image from './image.svelte';
	import PageGrid from './pageGrid.svelte';

	interface Props {
		story: SbBlogArticleStory;
	}

	let { story }: Props = $props();

	let category = $derived(story.content.category?.content);
</script>

<DesktopPageGrid>
	<a href="/{story.full_slug}" class="group col-span-full">
		<article class="w-full lg:flex">
			<div class="aspect-3/2 overflow-hidden lg:w-1/2 lg:rounded-l-2xl">
				{#if story.content.hero_image?.filename}
					<Image
						class="h-full w-full transform-gpu object-cover object-center transition-transform duration-600 group-hover:scale-105"
						src={story.content.hero_image.filename}
						alt={story.content.hero_image.alt ?? ''}
						title={story.content.hero_image.title ?? ''}
						width={780}
						sizes={{ 1024: { width: 2280 } }}
					/>
				{/if}
			</div>
			<div
				class="bg-{category?.hero_background_color ||
					'transparent'} py-5 lg:w-1/2 lg:rounded-r-2xl lg:p-14"
			>
				<PageGrid>
					<div class="col-span-full flex flex-col items-start gap-y-3 lg:gap-y-[22px]">
						{#if !story.full_slug.startsWith('news/')}
							{#if category}
								<div
									class="bg-{category.hero_badge_color} text-{category.hero_badge_text_color} rounded-[4px] p-2 text-[14px]/[100%] font-semibold lg:px-3 lg:py-2 lg:text-[18px]/[100%]"
								>
									{category.name}
								</div>
							{/if}
						{/if}
						<h1
							class="text-[24px]/[110%] font-semibold text-brown-2 lg:text-[56px]/[110%] lg:tracking-[-0.56px]"
						>
							{story.content.title}
						</h1>
						<div class="text-[14px]/[140%] text-brown-3 lg:text-[16px]/[110%]">
							{getBlogArticleSubHeading(story)}
						</div>
					</div>
				</PageGrid>
			</div>
		</article>
	</a>
</DesktopPageGrid>
